import { useDispatch, useSelector } from "react-redux";
import { setConfirmation } from "../ducks/userSlice";
import { setFormAnswer } from "../ducks/checkoutSlice";
import useGoTo from "./useGoTo";
import useToast from "./useToast";

// Fecha o login vindo de qualquer um dos três caminhos: cadastro novo, senha e
// código + senha. Guarda a sessão (id + uuid), aproveita nome e telefone no
// formulário do checkout e volta para a tela inicial.
export default function useFinishLogin() {
  const dispatch = useDispatch();
  const goTo = useGoTo();
  const toast = useToast();
  const { name, telephone } = useSelector((state) => state.checkout);

  return (user) => {
    if (!name) {
      dispatch(setFormAnswer({ name: "name", value: user.nome }));
    }

    if (!telephone) {
      dispatch(setFormAnswer({ name: "telephone", value: user.telefone }));
    }

    dispatch(setConfirmation(user));
    toast.toastSuccess("Login realizado com sucesso!");
    goTo("/");
  };
}
